import $ from 'jquery';

window.learningCenter = function() {
    var tags = [];
    var categories = [];
    var searchTerm = "";
    var searchType = "posts";
    var selectedTypes = [];
    var articleFilter = "";
    var siteCategories = [];
  
    var getSiteCategories = function() {
      $.ajax({
        url: "/wp-json/wp/v2/categories",
        type: "GET",
        success: function(categories) {
          siteCategories = siteCategories.concat(categories);
        }
      });
      $.ajax({
        url: "/wp-json/wp/v2/news_category",
        type: "GET",
        success: function(categories) {
          siteCategories =  siteCategories.concat(categories);
        }
      });
    };
  
    getSiteCategories();
  
  
  var  getCookie = function(cname) {
      var name = cname + "=";
      var ca = document.cookie.split(';');
      for(var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
              c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
              return c.substring(name.length, c.length);
          }
      }
      return "";
  }
  
  var setCookie = function(cname, cvalue, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
      var expires = "expires="+d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
  
  var lcToggleMenu = function() {
      var menuItem = $('#lc-menu');
      if(menuItem.hasClass("active")){
        setCookie("showing_lc_menu", false, 365);
        menuItem.removeClass("active");
      }else{
        setCookie("showing_lc_menu", true, 365);
        menuItem.addClass("active");
      }
    };
  
    $('.category-group-of-tabs').on('click', '.category-tab',
      function() {
      var category = $(this).data('category');
      $('.category-group-of-tabs').children('.category-tab').removeClass('active');
  
      $(this).addClass('active');
      $(".category-article-blocks")
        .children(".article-block")
        .not("." + category)
        .hide();
      $(".category-article-blocks").children("." + category).css('display', 'block');
      $(".category-callout").attr(
        "href",
        "/learning-center/category/" + category.replace("lc-cat-", "")
      );
    });
	
	var dropdownTrigger = document.getElementById("category-group-of-news-dropdown");

	if (null !== dropdownTrigger) {
	  var dropdownList = document.querySelector(".dropdown-list");
	  var dropdownArrow = dropdownTrigger.querySelector(".fa-sort-desc");
	
	  if (dropdownTrigger && dropdownList && dropdownArrow) {
		// Add click event listener to the dropdown trigger (unchanged)
		dropdownTrigger.addEventListener("click", function(event) {
		  // Prevent event bubbling from triggering the document click listener
		  event.stopPropagation();
	
		  dropdownList.classList.toggle("show-dropdown");
		  dropdownArrow.classList.toggle("rotate-arrow");
		});
	
		// Add click event listener to the document to close the dropdown on outside click
		document.addEventListener("click", function(event) {
		  // Check if the clicked element is not the dropdown trigger or its content
		  if (
			!dropdownTrigger.contains(event.target) &&
			dropdownList.classList.contains("show-dropdown")
		  ) {
			dropdownList.classList.remove("show-dropdown");
			dropdownArrow.classList.remove("rotate-arrow");
		  }
		});
	  }
	}

    $('.category-group-of-news-tabs').on('click', '.category-tab',
      function() {
      var category = $(this).data('category');
      $('.category-group-of-news-tabs').children('.category-tab').removeClass('active');
  
  
      $(this).addClass('active');
      $(".category-article-blocks")
        .children(".article-block")
        .not("." + category)
        .hide();
  
      $(".callout-links")
        .children()
        .not("." + category)
        .hide();
      $(".category-article-blocks").children("." + category).css('display', 'block');
      $(".callout-links").children("." + category).css('display', 'inline-block');
      // $('.callout-links').children('.callout-link').removeClass('active');
    });
  
  
  var getParameterByName = function(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, " "));
  }
  
  
  var searchByCategory = function(searchTerm) {
      var elem = $(".cat-" + searchTerm);
      var index = $.inArray(searchTerm, categories);
      if (index != -1) {
        elem.removeClass("active");
        categories.splice(index, 1);
      } else {
        elem.addClass("active");
        categories.push(searchTerm);
      }
  
      searchLC();
    };
  var searchByTag = function(tag) {
      var elem = $(".tag-" + tag);
      var index = $.inArray(tag, tags);
      if (index != -1) {
        elem.removeClass("active");
        tags.splice(index, 1);
      } else {
        elem.addClass("active");
        tags.push(tag);
      }
      searchLC();
    };
  
  var searchByType = function(type, e) {
      var types = e.parentNode.children;
      if(selectedTypes.indexOf(type) > -1){
        selectedTypes.splice(selectedTypes.indexOf(type),1);
        $(e).removeClass("active");
      } else {
        selectedTypes.push(type);
        $(e).addClass("active");
      }
      articleFilter = '';
      if(selectedTypes.length > 0){
        // build article filter
        articleFilter = '&filter[meta_query][relation]=OR';
        for(i = 0; i < selectedTypes.length; i++) {
          articleFilter += '&filter[meta_query][' + i + '][key]=article_type&filter[meta_query][' + i + '][value]=' + selectedTypes[i] + '&filter[meta_query][' + i + '][compare]==';
        }
      }
      searchLC();
    };
  
  var searchLC = function() {
      var isNews = false;
      if(getParameterByName("post_type") === "news"){
        searchType = "news";
        isNews = true;
      }
  
      var base_query = "/wp-json/wp/v2/" + searchType + "?orderby=date&order=desc" + articleFilter;
      if (categories.length > 0) {
        var searchCatTitle = isNews ? "news_category" : "categories";
        base_query += "&" + searchCatTitle + "=" + categories.join(",");
      }
      if (tags.length > 0) {
        base_query += "&tags=" + tags.join(",");
      }
  
      if ($(".search-field").val()) {
        base_query += "&search=" + $(".search-field").val();
      }
      base_query += "&_embed";
  
      $.ajax({
        url: base_query,
        type: "GET",
        success: function(postItems) {
          // console.log(base_query);
          $(".search-items").html("");
  
          $.each(postItems, function(index, postItem) {
            // console.log(postItem);
            var category_name = "";
  
            if(isNews){
              if (postItem.news_category.length > 0) {
                for (var i = 0; i < siteCategories.length; i++) {
                  if (siteCategories[i].id === postItem.news_category[0]) {
                    category_name = siteCategories[i].name;
                  }
                }
              }
            }else{
              if (postItem.categories.length > 0) {
                for (var i = 0; i < siteCategories.length; i++) {
                  if (siteCategories[i].id === postItem.categories[0]) {
                    console.assert(siteCategories[i])
                    category_name = siteCategories[i].name;
                  }
                }
              }
            }
            var post_url = '';
  
            if(typeof postItem._embedded["wp:featuredmedia"] !== "undefined"){
              post_url = postItem._embedded["wp:featuredmedia"][0].source_url; //wow.
            }
  
            $(".search-items").append(
              '<a class="article-block lc-cat-inventory " href="' +
                postItem.link +
                '" style="display: inline;"> \
                          <div class="article-block_image-area"> \
                            <img src="' +
                post_url +
                '">\
                            <span class="article-block_time with-icon">\
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 16" version="1.1">\
                                <g transform="translate(-16.000000, -8.000000)" fill="currentColor">\
                                  <path d="M21.6 9.6L17.6 9.6C17.6 9.6 17.6 22.4 17.6 22.4 17.6 22.4 27.2 22.4 27.2 22.4 27.2 22.4 27.2 17.74 27.2 15.2L22.4 15.2C21.96 15.2 21.6 14.84 21.6 14.4L21.6 9.6ZM23.2 9.6L23.2 13.6 27.2 13.6 23.2 9.6ZM17.6 8L23.44 8C23.66 8 23.97 8.13 24.12 8.28L28.52 12.68C28.67 12.83 28.8 13.14 28.8 13.36L28.8 22.4C28.8 23.28 28.08 24 27.2 24L17.6 24C16.72 24 16 23.28 16 22.4L16 9.6C16 8.72 16.72 8 17.6 8ZM18.4 20C18.4 19.56 18.76 19.2 19.2 19.2L25.6 19.2C26.04 19.2 26.4 19.56 26.4 20 26.4 20.44 26.04 20.8 25.6 20.8L19.2 20.8C18.76 20.8 18.4 20.44 18.4 20ZM18.4 17.6C18.4 17.16 18.76 16.8 19.19 16.8L22.41 16.8C22.85 16.8 23.2 17.16 23.2 17.6 23.2 18.04 22.84 18.4 22.41 18.4L19.19 18.4C18.75 18.4 18.4 18.04 18.4 17.6Z"></path>\
                                </g>\
                              </svg>\
                              3 min Read\
                            </span>\
                          </div>\
                          <div class="article-block_info">\
                            <span class="article-block_category">' +
                category_name +
                '</span>\
                            <span class="article-block_title">' +
                postItem.title.rendered +
                '</span>\
                            <span class="article-block_description"><p class="p1"><span class="s1">' +
                $(postItem.content.rendered).text().substring(0, 100) +
                '...</span>\
                            <span class="article-block_read-link">\
                              <span>Read Article</span>\
                              <svg viewBox="0 0 8 16" xmlns="http://www.w3.org/2000/svg">\
                                <path fill="currentColor" d="M0 4.998l3.063 3L0 11v5l8.033-8L0 0z"></path>\
                              </svg>\
                            </span>\
                          </p></span></div></a>'
            );
          });
        }
      });
    };
  
};
  